<template>
  <div>
    <v-card class="formio-container">
      <template v-if="!code">
        <p class="text--secondary text-center subtitle-1 ma-0">{{ $t('vuetifyWidgets.dr-process.specifyTheFormCode') }}</p>
      </template>
      <template v-else-if="code && showProcessing">
        <div class="d-flex justify-center align-self-center flex-column align-center">
          <div class="d-flex text--secondary mb-4">{{ $t('vuetifyWidgets.dr-process.loadingTheForm') }}</div>
          <v-progress-circular class="progress-loader" :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
      </template>
      <template v-else-if="form">
        <v-card-title>
          {{ form.name }}
        </v-card-title>
        <v-card-text>
          <formio-form-component ref="form" :formCode="formCode" :formDefinition="form" />
        </v-card-text>

        <v-card-actions>
          <v-btn v-if="!model.WithoutSubmitButton" @click="onClick" :disabled="startProcessLoading || isDisabledBtn" color="primary">
            {{ startProcessBtnLabel }}
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </div>
</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  name: 'dr-process-component',
  mixins: [baseMixin, inputMixin],
  data: () => ({
    form: null,
    procDefId: null,
    processItems: null,
    startProcessLoading: false,
    showProcessing: false
  }),
  computed: {
    code() {
      return this.model.Process
    },
    startProcessBtnLabel() {
      return this.evaluateExpression(this.model.StartProcessButton) || this.$t('vuetifyWidgets.dr-process.startProcess')
    },
    isDisabledBtn() {
      return typeof this.isDisabled === 'string' ? false : this.isDisabled
    }
  },
  watch: {
    code: async function () {
      await this.initForm(this.code)
    }
  },
  methods: {
    async onClick() {
      const formResult = await this.formSubmit()
      if (this.model.OnProcessStarted == 'dataSourceAction') {
        this.$emit('callDataSourceAction', {
          action: 'ProccesStarted',
          params: { result: formResult }
        })
      }
    },
    getUserId() {
      return this.$store.dispatch('processes/getUserId')
    },
    async formSubmit() {
      if (this.form) {
        this.startProcessLoading = true
        const form = this.$refs.form
        try {
          const submitFormResult = await form.submit()
          if (!submitFormResult.success) {
            return { submitFormResult }
          }
          const processResult = await this.startProcess(submitFormResult.submission)
          return { submitFormResult, processResult }
        } catch (e) {
          console.error(e)
        } finally {
          this.startProcessLoading = false
        }
      }
    },
    async startProcess(data) {
      const processData = {
        ProcessDefinitionId: this.procDefId,
        BusinessKey: `USER[${await this.getUserId()}]`,
        Variables: this.getVariables(data)
      }
      try {
        const data = await this.$store.dispatch('processes/startProcess', processData)
        return JSON.parse(data)
      } catch (e) {
        console.error(e.message)
      }
    },
    getVariables(data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      const variables = []
      for (const field in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(field)) {
          const Name = field
          const Value = data[Name]
          variables.push({ Name, Value })
        }
      }
      this.defineTypes(variables)
      return variables
    },
    defineTypes(variables) {
      variables.forEach((variable) => {
        const value = variable.Value
        let type = typeof value
        if (type === 'number') {
          type = value.toString().includes('.') ? 'Double' : 'Integer'
        } else {
          // Capitalize
          type = type.replace(/\S/, (s) => s.toUpperCase())
        }
        variable.Type = type
      })
    },
    async initForm(id) {
      this.showProcessing = true
      const formioParams = this.createFormioParams(this.model.FormioParams)
      const result = await this.$store.dispatch('processes/getFormDefinition', id)
      if (result) {
        if (result.success) {
          const data = JSON.parse(result.data)
          this.procDefId = result.procDefId
          const formCode = (this.formCode = data.unformio)
          const deviceSizeType = this.$vuetify.breakpoint.name
          this.form = await this.$store.dispatch('formio/getForm', {
            formCode,
            deviceSizeType,
            properties: formioParams
          })
        } else {
          console.error(result.errorMessage)
        }
      } else {
        console.error('Undefined Form Of Process')
      }
      this.showProcessing = false
    },
    createFormioParams(formioParams) {
      if (!formioParams) {
        return {}
      }

      let params = {}
      for (const property in formioParams) {
        const value = this.getExternalSourceField(formioParams[property])
        params[property] = value ?? formioParams[property]
      }

      return params
    }
  },
  async created() {
    if (!this.code) {
      return
    }

    await this.initForm(this.code)
  }
}
</script>
<style scoped>
.formio-container {
  box-shadow: none !important;
  background-color: transparent !important;
}
.progress-loader {
  display: block;
  width: 100px;
  margin: 0 auto;
}
</style>
